import { createRoute, defer } from '@tanstack/react-router'

import { entitySubscriptionsQueryOptions } from '@/features/subscriptions'
import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import { bookingQueryOptions } from '../../../api/booking'
import { BookingErrorComponent, BookingPendingLayout } from '../components/BookingLayout'

export const bookingRootRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bookings/$id',
  beforeLoad: ensureAuthenticatedUser,
  errorComponent: BookingErrorComponent,
  loader: async ({ context, params: { id } }) => {
    if (!context.queryClient) return
    const subscriptions = context.queryClient?.ensureQueryData(entitySubscriptionsQueryOptions(id))
    // to show the main spinner only for the main booking data, remove the defer
    const booking = context?.queryClient?.ensureQueryData(bookingQueryOptions(id))
    return { booking: defer(booking), subscriptions: defer(subscriptions) }
  },
  pendingComponent: BookingPendingLayout,
}).lazy(() => import('./BookingRoot').then((d) => d.Route))

export const bookingDetailsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bookings/$id/details',
  beforeLoad: ensureAuthenticatedUser,
  errorComponent: BookingErrorComponent,
  loader: async ({ context, params: { id } }) => {
    if (!context.queryClient) return
    const booking = context.queryClient?.ensureQueryData(bookingQueryOptions(id))
    return { booking: defer(booking) }
  },
  pendingComponent: BookingPendingLayout,
}).lazy(() => import('./BookingDetails').then((d) => d.Route))

export const bookingContainersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bookings/$id/containers',
  beforeLoad: ensureAuthenticatedUser,
  errorComponent: BookingErrorComponent,
  loader: async ({ context, params: { id } }) => {
    if (!context.queryClient) return
    const booking = context.queryClient?.ensureQueryData(bookingQueryOptions(id))
    return { booking: defer(booking) }
  },
  pendingComponent: BookingPendingLayout,
}).lazy(() => import('./BookingContainers').then((d) => d.Route))

export const bookingPriceBreakdownRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bookings/$id/price-breakdown',
  beforeLoad: ensureAuthenticatedUser,
  errorComponent: BookingErrorComponent,
  loader: async ({ context, params: { id } }) => {
    if (!context.queryClient) return
    const booking = context.queryClient?.ensureQueryData(bookingQueryOptions(id))
    return { booking: defer(booking) }
  },
  pendingComponent: BookingPendingLayout,
}).lazy(() => import('./BookingPriceBreakdown').then((d) => d.Route))

export const bookingCustomsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bookings/$id/customs',
  beforeLoad: ensureAuthenticatedUser,
  errorComponent: BookingErrorComponent,
  loader: async ({ context, params: { id } }) => {
    if (!context.queryClient) return
    const booking = context.queryClient?.ensureQueryData(bookingQueryOptions(id))
    return { booking: defer(booking) }
  },
  pendingComponent: BookingPendingLayout,
}).lazy(() => import('./BookingCustoms').then((d) => d.Route))

export const bookingDocumentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bookings/$id/documents',
  beforeLoad: ensureAuthenticatedUser,
  errorComponent: BookingErrorComponent,
  loader: async ({ context, params: { id } }) => {
    if (!context.queryClient) return
    const booking = context.queryClient?.ensureQueryData(bookingQueryOptions(id))
    return { booking: defer(booking) }
  },
  pendingComponent: BookingPendingLayout,
}).lazy(() => import('./BookingDocuments').then((d) => d.Route))
